import { render, staticRenderFns } from "./TransactionViewFullDate.vue?vue&type=template&id=65885df2&scoped=true&"
import script from "./TransactionViewFullDate.vue?vue&type=script&lang=js&"
export * from "./TransactionViewFullDate.vue?vue&type=script&lang=js&"
import style0 from "./TransactionViewFullDate.vue?vue&type=style&index=0&id=65885df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65885df2",
  null
  
)

export default component.exports